module.exports = "<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/@fuse/components/sidebar/sidebar.component.html
// module id = ./src/@fuse/components/sidebar/sidebar.component.html
// module chunks = main